__turbopack_context__.v({
  "AllComplete": "YGjurG_AllComplete",
  "BlobAddButton": "YGjurG_BlobAddButton",
  "BlobCheckboxLabel": "YGjurG_BlobCheckboxLabel",
  "BlobEditor": "YGjurG_BlobEditor",
  "BlobEmpty": "YGjurG_BlobEmpty",
  "BlobField": "YGjurG_BlobField",
  "BlobFieldLabel": "YGjurG_BlobFieldLabel",
  "BlobList": "YGjurG_BlobList",
  "BlobListItems": "YGjurG_BlobListItems",
  "BlobRemoveButton": "YGjurG_BlobRemoveButton",
  "BlobRow": "YGjurG_BlobRow",
  "BlobRowHeader": "YGjurG_BlobRowHeader",
  "BlobRowTitle": "YGjurG_BlobRowTitle",
  "BlobSection": "YGjurG_BlobSection",
  "BlobSectionTitle": "YGjurG_BlobSectionTitle",
  "DocsLink": "YGjurG_DocsLink",
  "Error": "YGjurG_Error",
  "Example": "YGjurG_Example",
  "Field": "YGjurG_Field",
  "FieldActions": "YGjurG_FieldActions",
  "FieldLabel": "YGjurG_FieldLabel",
  "FilterChip": "YGjurG_FilterChip",
  "FilterChipActive": "YGjurG_FilterChipActive",
  "FilterChips": "YGjurG_FilterChips",
  "GroupCount": "YGjurG_GroupCount",
  "GroupEmpty": "YGjurG_GroupEmpty",
  "GroupSearch": "YGjurG_GroupSearch",
  "Help": "YGjurG_Help",
  "Invalid": "YGjurG_Invalid",
  "Missing": "YGjurG_Missing",
  "MissingSummary": "YGjurG_MissingSummary",
  "MissingSummaryList": "YGjurG_MissingSummaryList",
  "MissingSummaryTitle": "YGjurG_MissingSummaryTitle",
  "Panel": "YGjurG_Panel",
  "PanelBody": "YGjurG_PanelBody",
  "PanelHeader": "YGjurG_PanelHeader",
  "PanelTitle": "YGjurG_PanelTitle",
  "Required": "YGjurG_Required",
  "Resource": "YGjurG_Resource",
  "ResourceActions": "YGjurG_ResourceActions",
  "ResourceBadge": "YGjurG_ResourceBadge",
  "ResourceBadgeOk": "YGjurG_ResourceBadgeOk",
  "ResourceBody": "YGjurG_ResourceBody",
  "ResourceSubtitle": "YGjurG_ResourceSubtitle",
  "ResourceSummary": "YGjurG_ResourceSummary",
  "ResourceTitle": "YGjurG_ResourceTitle",
  "SaveButton": "YGjurG_SaveButton",
  "StatusError": "YGjurG_StatusError",
  "StatusSaved": "YGjurG_StatusSaved",
  "SummaryLink": "YGjurG_SummaryLink",
  "Toolbar": "YGjurG_Toolbar",
  "ToolbarSearch": "YGjurG_ToolbarSearch",
});
